import { Campanha } from '../../campanha';

export interface CampanhaSelect {
    id: number;
    idEmpresa: number;
    numero: number;
    nome: string;
    status: number;
    idArea: number;
    nomeArea?: string;

    // Cliente
    idCliente?: number;
    codigoIntegracaoErpCliente?: string;
    cnpjCpfCliente?: string;
    nomeCliente?: string;
    nomeFantasiaCliente?: string;

    // Configurações Anvançadas
    permitirCadastrarLeadSemCnpjCpf?: boolean;
    // Tabela de Preço
    quantidadeTabelasPrecos?: number;
}

/** Map CampanhaSelect to Campanha*/
export function mapToCampanha(campanhaSelect: CampanhaSelect): Campanha {
    if (!campanhaSelect) {
        return null;
    }

    const campanha = new Campanha();
    campanha.id = campanhaSelect.id;
    campanha.idEmpresa = campanhaSelect.idEmpresa;
    campanha.numero = campanhaSelect.numero;
    campanha.nome = campanhaSelect.nome;
    campanha.status = campanhaSelect.status;
    campanha.idArea = campanhaSelect.idArea;
    campanha.idCidade = campanhaSelect.idCliente;
    campanha.permitirCadastrarLeadSemCnpjCpf = campanhaSelect.permitirCadastrarLeadSemCnpjCpf;
    campanha.quantidadeTabelasPrecos = campanhaSelect.quantidadeTabelasPrecos;

    return campanha;
}
